import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { ExternalLinks } from '@utils/constants/PageUrls';
import BlokoIcon from '@images/icons/bloko.svg';
import OckoIcon from '@images/icons/ocko.svg';

import * as styles from './OurProducts.module.scss';

export const OurProducts: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer>
				<h2 className="font-size-medium mb-4">Our products</h2>
				<div
					className={classNames(
						styles.container,
						'd-flex flex-column flex-sm-row'
					)}
				>
					<Link
						to={ExternalLinks.BLOKO}
						target="_blank"
						rel="nofollow"
						className={styles.left}
					>
						<img src={BlokoIcon} alt="Bloko logo" />
					</Link>
					<Link
						to={ExternalLinks.OCKO}
						target="_blank"
						rel="nofollow"
						className={styles.right}
					>
						<img src={OckoIcon} alt="Ocko logo" />
					</Link>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
